import type { AvailabilitySlot, AvailabilityWindow } from "components/Screens/Marketplace/Customer/types";

export const SLOT_OPTIONS: { value: AvailabilitySlot; label: string }[] = [
  { value: "morning", label: "Morning" },
  { value: "afternoon", label: "Afternoon" },
  { value: "evening", label: "Evening" },
];

// Prototype TZ table; anything unlisted is Eastern.
const TZ: Record<string, string> = {
  CA: "PT", WA: "PT", OR: "PT", NV: "PT",
  AZ: "MT", CO: "MT", UT: "MT", NM: "MT", MT: "MT", ID: "MT", WY: "MT",
  TX: "CT", IL: "CT", MN: "CT", WI: "CT", IA: "CT", MO: "CT", AR: "CT", LA: "CT", MS: "CT", AL: "CT", OK: "CT", KS: "CT", NE: "CT", SD: "CT", ND: "CT", TN: "CT",
  AK: "AKT", HI: "HT",
};

export const timeZoneForState = (state?: string) => (state && TZ[state.toUpperCase()]) || "ET";

export function nextWeekdays(count: number, from: Date = new Date()): Date[] {
  const out: Date[] = [];
  const d = new Date(from.getFullYear(), from.getMonth(), from.getDate());
  while (out.length < count) {
    d.setDate(d.getDate() + 1);
    if (d.getDay() % 6) out.push(new Date(d));
  }
  return out;
}

const pad = (n: number) => String(n).padStart(2, "0");
export const toIsoDate = (d: Date) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

const DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/;

// "YYYY-MM-DD" is a calendar date (availability windows); anything else is an instant shown in local time.
const fromIso = (s: string) => {
  if (!DATE_ONLY.test(s)) return new Date(s);
  const [y, m, day] = s.split("-").map(Number);
  return new Date(y, m - 1, day);
};

export function fmtDay(d: Date | string): string {
  const date = typeof d === "string" ? fromIso(d) : d;
  return date.toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric" });
}

export function defaultWindows(days: Date[]): AvailabilityWindow[] {
  return [0, 1, 2].map((i) => ({ date: toIsoDate(days[i * 2] || days[0]), slot: SLOT_OPTIONS[i % 3].value }));
}
